module.exports = __webpack_public_path__ + "static/report-b960eaa0048f7bc22215a2025b489899.png";